import Icon from "../icons/Icon";
// src/components/dashboard/AdjustmentsCard.js
// Dashboard card — pending adjustment entries awaiting a payroll run (BL-076).
// Visibility gated by `adj:view` via src/config/dashboardCards.js.
// Returns null until the summary has loaded, mirroring OtApprovalCard's guard
// so the card never flashes a false zero.

import { formatPeso } from "../../utils/currency";

export const AdjustmentsCard = ({ adjustmentsSummary, navigate, company }) => {
  if (adjustmentsSummary == null) return null;

  const { count, net } = adjustmentsSummary;
  const goToAdjustments = () =>
    navigate(`/company/${company.slug}/adjustments`);

  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <span className="dashboard-card__title">Adjustments</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            goToAdjustments();
          }}
          className="dashboard-card__link"
        >
          View All →
        </a>
      </div>
      {count > 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            padding: 16,
            background: "var(--ui-warning-tint)",
            borderRadius: 10,
            marginBottom: 16,
            cursor: "pointer",
          }}
          onClick={goToAdjustments}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Icon name="file-pen" size={20} />
          </div>
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "var(--ui-warning-text)",
                fontVariantNumeric: "tabular-nums",
                lineHeight: 1,
              }}
            >
              {count}
            </div>
            <div style={{ fontSize: 13, color: "var(--ui-warning-text)", fontWeight: 500 }}>
              {count === 1
                ? "Pending entry — not yet paid"
                : "Pending entries — not yet paid"}
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: 16,
            textAlign: "center",
            color: "var(--ui-text-muted)",
            fontSize: 14,
            marginBottom: 16,
          }}
        >
          No pending adjustments
        </div>
      )}
      <div
        style={{
          textAlign: "center",
          padding: "12px 8px",
          background: "var(--ui-bg)",
          borderRadius: 8,
        }}
      >
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            // Net can go negative when pending deductions outweigh earnings —
            // colour it like a deduction so the sign is not the only signal.
            color: net < 0 ? "var(--ui-danger)" : "var(--ui-primary-hover)",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {formatPeso(net)}
        </div>
        <div style={{ fontSize: 11, color: "var(--ui-text-muted)", fontWeight: 500 }}>
          Net impact when paid
        </div>
      </div>
    </div>
  );
};
